import { superAdminMenuItems } from '@/config/super-admin-menu.config';
import SecondarySidebarLayout from './secondary-sidebar-layout';

export default function SuperAdminDeveloperLayout() {
	const developersItem = superAdminMenuItems.find((item) => item.activePrefix === '/super-admin/developers');
	const subItems = developersItem?.subItems ?? [];

	return <SecondarySidebarLayout title='Developers' items={subItems} />;
}
